import logo from '../../assets/img/logo.png';
import loadingGif from '../../assets/img/loading.gif';
import React, { useState } from "react";
import axios from "axios";
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import Swal from 'sweetalert2'

export default function ForgetPassword() {

    const [loading, setLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [mailGonderildi, setMailGonderildi] = useState(0);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (userName === "") {
            Swal.fire({ title: "Hata", text: "E-posta adresinizi giriniz", icon: "error" });
            return;
        }

        axios.get(settings.ApiUrl + 'Login/GetAktivasyonKoduByMail/' + userName, { headers: { 'Content-Type': 'application/json' }, withCredentials: false })
            .then((result) => {
                setLoading(true);

                const r = result.data.value;

                if (r === "KayitYok") {
                    setLoading(false);
                    Swal.fire({ title: "Hata", text: "Kullanıcı bulunamadı", icon: "error" });
               } else {
                    const url = "<a href='" + window.location.origin + "/Auth/ActivatePassword?C=" + r + "'>Şifrenizi belirlemek için tıklayınız</a>";

                    const postData = JSON.stringify({
                        "yeniKullanici": false,
                        "url": url,
                        "mail": userName
                    });

                    axios.post(settings.ApiUrl + 'Mail/SendPasswordLink/', postData, { headers: { 'Content-Type': 'application/json' }, withCredentials: false })
                        .then((result) => {
                            setLoading(false);
                            setUserName("");

                            if (result.data.success) {
                                setMailGonderildi(1);
                            } else {
                                Swal.fire({ title: "Hata", text: result.data.message, icon: "error" });
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            Swal.fire({ title: "Hata", text: error, icon: "error" });
                        });
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);

                if (error.response) {
                    Swal.fire({ title: "Hata", text: error.response.data.detail, icon: "error" });
                } else if (error.request) {
                    Swal.fire({ title: "Hata", text: "network error", icon: "error" });
                } else {
                    Swal.fire({ title: "Hata", text: error, icon: "error" });
                }
            });
    };

    return (
        <div>
            {
                loading ?
                    <div className="progressBackground">
                        <div className="progressPopup">
                            <img alt="Bekleyiniz..." src={loadingGif} width="100" height="100" />
                        </div>
                    </div>
                    :
                    ''
            }

            <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                            <div className="d-flex justify-content-center py-4">
                                <a href="https://www.tedas.gov.tr" className="logo d-flex align-items-center w-auto">
                                    <img src={logo} alt=""></img>
                                </a>
                            </div>

                            <div className="card mb-3">

                                <div className="card-body">

                                    <div className="pt-2 pb-2">
                                        <h5 className="card-title text-center pb-0 fs-4">ATGroup</h5>
                                    </div>

                                    <div className="row g-3 needs-validation">

                                        <div className="col-12" style={{display: (mailGonderildi === 0 ? "block" : "none") }}>
                                            {/* <label htmlFor="tbUserName" className="form-label">E-Posta</label> */}
                                            <div className="input-group has-validation">
                                                <span className="input-group-text" id="inputGroupPrepend"><i className="bi bi-person-fill"></i></span>
                                                <input id="tbUserName" name="username" className="form-control" value={userName} onChange={(e) => setUserName(e.target.value)}
                                                    type="text" placeholder="E-posta adresiniz" autoComplete="off" required />
                                                <div className="invalid-feedback">E-posta adresinizi giriniz.</div>
                                            </div>
                                        </div>

                                        <div className="col-12" style={{display: (mailGonderildi === 0 ? "block" : "none") }}>
                                            <button className="btn btn-primary btn-block w-100" onClick={handleSubmit}>Şifre Oluştur</button>
                                        </div>

                                        <div className="col-12" style={{display: (mailGonderildi === 1 ? "block" : "none") }}>
                                            <div className="alert alert-success mb-0 text-center" style={{ fontSize: "smaller" }}>
                                                Şifre oluşturma linki e-posta adresinize gönderildi. Lütfen e-posta adresinizin gelen e-posta ve gereksiz e-posta bölümlerini kontrol ediniz.
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="credits">
                                <a href="/" style={{ fontWeight: '600' }}>Giriş Sayfası</a>
                            </div>

                        </div>
                    </div>
                </div>

            </section>

        </div>
    );
}